import { EpimsBaseEntityDto } from './epim-base.dto';
export class AcquisitionTypeDto extends EpimsBaseEntityDto {
    AcquisitionTypeName: string;
    SubscriptionUserId: string;
    Version: number;
}